module.exports = __webpack_public_path__ + "images/79a0bb772f25d5aa04d73e7e0e896a12-Audiowide-Regular.svg";